import { Component, OnInit } from "@angular/core";
import { User } from "../../../_models";
import { UserService } from "../../../_services";
import { CardState, PortalActionRow } from "../../data-visualization";
import {
  OverviewAiInsight,
  OverviewCardState,
  faqs,
  marketplaceSummaryCells,
  overviewAiInsights,
  overviewSummaryHasActivity,
  portalActions,
  portalMoments,
  portalMomentsNameColumn,
  portalMomentsValueColumns,
  retentionSummaryCells,
  returnSummaryCells,
  supportSummaryCells,
  topFaqsNameColumn,
  topFaqsValueColumns,
  topIntentsDoughnutData,
  topIntentsTableData,
} from "../../overview";

@Component({
  selector: "app-overview-report",
  templateUrl: "./overview-report.component.html",
  styleUrls: ["./../../dashboard-section-v2.scss", "./../dashboard-report.component.scss"],
})
export class DashboardOverviewReportComponent implements OnInit {
  currentUser: User;

  /* Cards Data */
  supportSummaryCells = supportSummaryCells;
  retentionSummaryCells = retentionSummaryCells;
  marketplaceSummaryCells = marketplaceSummaryCells;
  returnSummaryCells = returnSummaryCells;
  summaryHasActivity = overviewSummaryHasActivity;

  /* Charts Data */
  portalMoments = portalMoments;
  portalMomentsNameColumn = portalMomentsNameColumn;
  portalMomentsValueColumns = portalMomentsValueColumns;
  topIntentsDoughnutData = topIntentsDoughnutData;
  topIntentsTableData = topIntentsTableData;
  overviewAiInsights: OverviewCardState<OverviewAiInsight> = overviewAiInsights;
  topFaqsNameColumn = topFaqsNameColumn;
  topFaqsValueColumns = topFaqsValueColumns;
  faqs = faqs;

  // Top-level rows only, and a copy, so the report never inherits the reader's expansions.
  portalActionsState: CardState<PortalActionRow> = { data: [], loading: false, noData: true };

  constructor(private userService: UserService) {}

  get showAiInsights(): boolean {
    return this.currentUser !== undefined && this.currentUser !== null && this.currentUser.is_staff;
  }

  ngOnInit() {
    this.userService.getCurrent().subscribe((user: User) => {
      this.currentUser = user;
    });
    this.portalActionsState = this.topLevelPortalActions(portalActions);
  }

  topLevelPortalActions(source: OverviewCardState<PortalActionRow>): CardState<PortalActionRow> {
    const rows = source.data.map((row: PortalActionRow) => ({
      action: row.action,
      count: row.count,
      pctActions: row.pctActions,
      pctSessions: row.pctSessions,
    }));
    return { data: rows, loading: source.loading, noData: source.noData };
  }
}
